import { Component, inject, input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReportControl } from '@xmedical/core';
import { ReportControlEditorService } from '../../services/report-control-editor.service';

@Component({
  selector: 'xmed-date-picker-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
  ],
  providers: [DatePipe],
  templateUrl: './date-picker-renderer.component.html',
  styleUrl: './date-picker-renderer.component.scss'
})
export class DatePickerRendererComponent implements OnInit {
  private editorService = inject(ReportControlEditorService);
  private datePipe = inject(DatePipe);

  control = input.required<ReportControl>();
  value: Date = new Date();

  ngOnInit(): void {
    const ctrl = this.control();
    if (ctrl?.value === '') {
      ctrl.value = this.datePipe.transform(this.value, 'YYYY-MM-dd') ?? '';
    }
    if (ctrl?.value !== '') {
      this.value = new Date(ctrl.value);
    }
  }

  onValueChanges(date: Date): void {
    this.control().value = this.datePipe.transform(date, 'YYYY-MM-dd') ?? '';
    this.editorService.triggerEvent();
  }
}
